import type { Dispatch, UnknownAction } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

/**
 * Typed hooks for one app's store.
 *
 * ```ts
 * export const { useAppDispatch, useAppSelector } =
 *   createTypedHooks<RootState, AppDispatch>();
 * ```
 *
 * Each app calls this once in `app/hooks.ts`; nothing in a component reaches
 * for the untyped `useSelector`.
 */
export function createTypedHooks<State, D extends Dispatch<UnknownAction>>() {
  return {
    useAppDispatch: useDispatch.withTypes<D>(),
    useAppSelector: useSelector.withTypes<State>(),
  };
}
